<template>
    <rkm-modal
        extra-large
        persistent
        ref="Modal"
        title="Solicitação"
    >
        <Form
            :solicitacao="solicitacao"
            @save="handleSave"
            @data-change="data = $event"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading || disableCancel"
                @click="cancel"
            >
                {{ solicitacao?.allowUpdate ? 'Cancelar' : 'Fechar' }}
            </rkm-button>

            <rkm-button
                v-if="solicitacao?.allowUpdate ?? false"
                :disabled="!!loading"
                @click="$refs.Form.handleSave()"
                color="primary"
            >
                {{ buttonSaveText }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        disableCancel() {

            return this.data && this.data.fezAgendamentoAgora
        },
        buttonSaveText() {

            if (this.data && this.data.isPrestadorTipoInterno && !this.data.fezAgendamentoAgora) {

                if (this.data.isStatusAgendado) {

                    return 'Agendar e salvar'
                }
                else if (this.data.isStatusReagendado) {

                    return 'Reagendar e salvar'
                }
            }

            return 'Salvar'
        },
    },
    data: () => ({
        solicitacao: null,
        data: null,
    }),
    methods: {
        open(solicitacao) {

            this.solicitacao = solicitacao

            this.$refs.Modal.show()
        },
        handleSave() {

            this.$emit('save')
            this.$refs.Modal.hide()
        },
    },
}
</script>